export default "__VITE_ASSET__BQcWqSyQ__"